import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/return-box-yellow.png'
import _imports_1 from '@/assets/img/icon/scan-orange.svg'


const _hoisted_1 = { class: "px-3 py-2" }
const _hoisted_2 = { class: "md:flex w-full justify-between items-center mb-3" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal w-full" }, "Proses Ke Keberangkatan", -1)
const _hoisted_5 = {
  key: 0,
  class: "flex flex-1 items-center p-2 rounded-lg gap-2 btn-chce-resi max-w-md"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-check color-blue-grey" }, null, -1)
const _hoisted_7 = { class: "color-blue-grey" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-user-plus font-bold color-primary" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "font-bold color-primary color-primary" }, "Pilih Kurir", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "h-full",
  style: {"border-left":"1px solid #607D8B"}
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "font-bold color-primary color-primary" }, "Pengembalian", -1)
const _hoisted_13 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Urutkan :  ")
const _hoisted_15 = { class: "flex w-full container-input-check-resi" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "icon-scan-input w-10"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "my-no-more" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_CardReadyDeliver = _resolveComponent("CardReadyDeliver")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogDetailResiX = _resolveComponent("DialogDetailResiX")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputIconRightGrey, {
                placeholder: "Cari No. Resi Disini ...",
                type: _ctx.$enumBase.input.text,
                modelValue: _ctx.inputSearchReceipt,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearchReceipt = $event)),
                canClick: true,
                onSubmitInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitSearchReceipt(_ctx.inputSearchReceipt))),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.submitSearchReceipt(_ctx.inputSearchReceipt)), ["enter"])),
                icon: _ctx.$icon.svg.searchEva,
                class: "extend"
              }, null, 8, ["type", "modelValue", "icon"])
            ]),
            (_ctx.dataSource.filter((x) => x.IsCheck).length)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("p", _hoisted_7, _toDisplayString(`${_ctx.dataSource.filter((x) => x.IsCheck).length} Resi Terpilih:`), 1),
                  _createVNode("div", {
                    class: "flex gap-2 ml-2 items-center cursor-pointer",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showingSidebar()))
                  }, [
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _hoisted_10,
                  _createVNode("div", {
                    class: "flex gap-2 ml-2 items-center cursor-pointer",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.packageReturn(_ctx.dataSource.filter((x) => x.IsCheck))))
                  }, [
                    _hoisted_11,
                    _hoisted_12
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_Multiselect, {
                    id: "timeOrder",
                    class: "can-not-empty input-primary",
                    modelValue: _ctx.orderBy,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.orderBy = $event)),
                    placeholder: "Waktu Order",
                    options: _ctx.orderOption,
                    label: "label",
                    searchable: true,
                    allowEmpty: false
                  }, null, 8, ["modelValue", "options"])
                ]))
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_InputText, {
              placeholder: "Scan barcode untuk terima paket di agen",
              ref: "inputCekResi",
              class: "input-pengecekan-resi input-primary w-full",
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.inputSearch = $event)),
              onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.submitSearch(_ctx.inputSearch)), ["enter"]))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (data, key) => {
              return (_openBlock(), _createBlock(_component_CardReadyDeliver, {
                key: key,
                data: data,
                index: key,
                class: "mb-5",
                useSelectQourier: false,
                onSettingSchedule: _ctx.settingSchedule,
                onToManifest: _ctx.toManifest,
                onShowDetailResiDialog: _ctx.showDetailResiDialog,
                isUseScheduleBtn: true
              }, null, 8, ["data", "index", "onSettingSchedule", "onToManifest", "onShowDetailResiDialog"]))
            }), 128)),
            _createVNode(_component_VueEternalLoading, {
              load: _ctx.loadData,
              "is-initial": _ctx.isInitial,
              "onUpdate:is-initial": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isInitial = $event)),
              class: "flex justify-center"
            }, {
              loading: _withCtx(() => [
                _createVNode(_component_ProgressSpinner, {
                  class: "h-14",
                  strokeWidth: "5"
                })
              ]),
              "no-more": _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["load", "is-initial"])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.showDialogDetail)
      ? (_openBlock(), _createBlock(_component_DialogDetailResiX, {
          key: 0,
          isShowDialog: _ctx.showDialogDetail,
          onHideDialog: _ctx.hideDialog,
          dataSource: _ctx.dataSourceModal,
          onShowDetailResiDialogAct: _ctx.showDetailResiDialog,
          onProcessScanResi: _ctx.processScanResi
        }, null, 8, ["isShowDialog", "onHideDialog", "dataSource", "onShowDetailResiDialogAct", "onProcessScanResi"]))
      : _createCommentVNode("", true)
  ]))
}